import { FILTERED_LISTING_MODULE_TYPE, NO_APLICA } from '@/app/lib/analytics/constants'

import { ANALYTICS_PAGE_TYPE } from './buildSubcategoriaAnalyticsContext'

/**
 * Constantes de analítica del listado de la PLP de subcategoría
 * (`components-fingerprint/Listado filtrado.csv`).
 *
 * ⚠️ PROVISIONAL — pendiente de confirmar con Analítica: la guía no fija el
 * `module_name` ni el `item_list_name` de esta PLP. Se sigue la convención de
 * agenda/promociones/lo-mas-vendido (`listado_<seccion>` / `listado_de_<seccion>`).
 */
export const ANALYTICS_MODULE_NAME = 'listado_subcategoria'

/** `item_list_id` = `<page_type>_<module_type>` (CSV → «Click en card del listado»). */
export const ANALYTICS_ITEM_LIST_ID = `${ANALYTICS_PAGE_TYPE}_${FILTERED_LISTING_MODULE_TYPE}`

/** Literal estable: categoría/provincia ya viajan en `page_hierarchy`. */
export const ANALYTICS_ITEM_LIST_NAME = 'listado_de_subcategoria'

/**
 * `no_aplica` por decisión de la tarea (CSV: `select_item` → `no_aplica`). La
 * página tiene "Vistos recientemente" encima, pero su presencia depende de una
 * cookie y haría oscilar la posición.
 */
export const ANALYTICS_MODULE_POSITION = NO_APLICA
